import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Base from '../../../src/js/classes/Base'
import gsap from 'gsap'

export default class Header extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				mobileMenu: document.querySelector('.e-MobileMenu'),
				main: document.querySelector('main'),
				toggle: '.e-Header__left__mobile button',
				links: 'a:not(.e-Header__logo)',
				homeLogo: document.querySelector('.e-Header__logo'),
			},
			state: {
				isHidden: false,
				menuToggled: false,
				isMobileMenuOpen: false,
			},
			classes: {
				ajaxLinks: 'ajax-links',
				active: 'active',
				isHidden: 'is-hidden',
				isActive: 'is-active',
				mobileMenuOpen: 'mobile-menu-open',
				mobileHeaderHidden: 'mobile-header-hidden',
				currentMenuItem: 'current-menu-item'
			},
		})

		this.scrollOffset = 200
		this.resize()
		this.addEvents()
	}

	addEvents() {
		// Add event listeners
		this.elements.links = gsap.utils.toArray(this.elements.links)
		this.setupScrollTrigger()
		window.addEventListener('resize', this.resize.bind(this))
		this.elements.toggle.addEventListener('click', this.onToggleMenu.bind(this))
		this.elements.links.forEach((link) => {
			link.addEventListener('click', this.onClickLink.bind(this))
		})
		this.elements.homeLogo.addEventListener('click', this.onClickHome.bind(this))
		this.highlightActiveLink() // Highlight on initial load
	}

	removeEvents() {
		// Remove event listeners
	}

	setupScrollTrigger() {
		ScrollTrigger.create({
			trigger: document.body,
			start: `top top-=${this.scrollOffset}`,
			onUpdate: (self) => {
				if (self.direction === -1) {
					this.setState({ isHidden: false })
				} else {
					this.setState({ isHidden: true })
				}
			},
		})
	}

	onClickHome(e) {
		this.resetLinks()
	}

	highlightActiveLink() {
		const currentPath = window.location.pathname.replace(/\/$/, '') // Remove trailing slash
		this.resetLinks()
		this.elements.links.forEach((link) => {
			const href = link.getAttribute('href')
			if (!href || href.trim().startsWith('#')) return // Ignore relative with #
			const linkPath = link.pathname.replace(/\/$/, '')
			console.log({ linkPath, currentPath });
			if (linkPath === currentPath) {
				console.log('match!')
				link.classList.add(this.classes.active)
				link.closest('li').classList.add(this.classes.currentMenuItem)
			} else {
				link.classList.remove(this.classes.active)
				link.closest('li').classList.remove(this.classes.currentMenuItem)
			}
		})
	}

	onClickLink(e) {
		const button = e.target
		const url = button.getAttribute('href').trim()
		const isValid = url && url !== '#' && !url.startsWith('javascript:')
		if (isValid) {
			this.element.classList.add(this.classes.ajaxLinks)
			this.resetLinks()
			button.classList.add(this.classes.active)
		}
	}

	onToggleMenu() {
		this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen })
	}

	onStateChange(newState) {
		if ('isHidden' in newState) {
			if (newState.isHidden) {
				this.showHeader()
			} else {
				this.hideHeader()
			}
		}
		if ('isMobileMenuOpen' in newState) {
			if (document.body.classList.contains('login-open')) {
				document.body.classList.remove('login-open')
			} else {
				if (newState.isMobileMenuOpen) {
					this.showMobileMenu()
				} else {
					this.hideMobileMenu()
				}
			}
		}
	}

	showMobileMenu() {
		document.body.classList.add(this.classes.mobileMenuOpen)
	}

	hideMobileMenu() {
		document.body.classList.remove(this.classes.mobileMenuOpen)
	}

	showHeader() {
		this.element.classList.add(this.classes.isHidden)
		document.body.classList.add(this.classes.mobileHeaderHidden)
	}

	hideHeader() {
		this.element.classList.remove(this.classes.isHidden)
		document.body.classList.remove(this.classes.mobileHeaderHidden)
	}

	resetLinks() {
		this.elements.links.forEach((link) => {
			link.classList.remove(this.classes.active)
		})
	}

	resize() {
		// const height = this.element.clientHeight
		// Update component
		// if (this.elements.main) {
		// 	gsap.set(this.elements.main, {
		// 		paddingTop: height,
		// 	})
		// }
		// if (this.elements.mobileMenu) {
		// 	gsap.set(this.elements.mobileMenu, {
		// 		paddingTop: height,
		// 	})
		// }
		// ScrollTrigger.refresh()
	}

	update() {}

	unmount() {}
}
